import { Delivery as DeliveryBase } from "@omni/components/components/Product/ECommerce/components/delivery/delivery";
import { cn } from "@omni/utils/styles";

import { DeliveryComponent } from "@/components/Product/ECommerce/components/delivery/delivery.component";

type Props = {
    className?: string;
};

export const Delivery = ({ className }: Props) => {
    return (
        <DeliveryBase className={cn(className)}>
            <DeliveryComponent />
        </DeliveryBase>
    );
};
